// src/pages/Professionnels.js
import React from "react";
import { Link } from "react-router-dom";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function Professionnels() {
  useSEO({
    title: "Photographe entreprise à Nancy | HLBK",
    description:
      "Photographe professionnel à Nancy et Tomblaine pour entreprises : portraits corporate, équipes, reportage métier, événements et communication.",
    canonical: `${window.location.origin}/professionnels`,
    image: `${window.location.origin}/images/og-default.jpg`,
  });

  const structuredData = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "HLBK Photo",
  url: "https://hlbk.fr/",
  image: "https://hlbk.fr/images/og-default.jpg",
  description:
    "Photographe professionnel à Nancy et Tomblaine pour entreprises : portraits corporate, équipes, reportage métier, événements et communication.",
  areaServed: [
    {
      "@type": "City",
      name: "Nancy",
    },
    {
      "@type": "City",
      name: "Tomblaine",
    },
    {
      "@type": "AdministrativeArea",
      name: "Grand Nancy",
    },
    {
      "@type": "AdministrativeArea",
      name: "Grand Est",
    },
  ],
  serviceType: [
    "Photographie d'entreprise",
    "Portrait professionnel",
    "Portrait corporate",
    "Photographie d'équipe",
    "Reportage métier",
    "Photographie événementielle",
  ],
};

  return (
    <main className="pro-page">

        <script
  type="application/ld+json"
  dangerouslySetInnerHTML={{
    __html: JSON.stringify(structuredData),
  }}
/>
      {/* HERO */}
      <section className="pro-hero">
        <div className="pro-hero-overlay" />

        <div className="pro-hero-content">
          <p className="pro-kicker">HLBK • ENTREPRISES</p>

        <h1>
          Des images professionnelles
         <span>qui donnent un visage</span>
          à votre entreprise.
        </h1>

          <p className="pro-lead">
  Portraits, équipes, métiers et savoir-faire :
  des images professionnelles pensées pour votre site,
  LinkedIn, vos réseaux sociaux et votre communication.
</p>

          <div className="pro-location">
            Tomblaine • Nancy & alentours • Grand Est
          </div>

          <div className="pro-actions">
            <Link to="/contact" className="btn-cta btn-cta-red">
              PARLER DE VOTRE PROJET
            </Link>

            <Link to="/galerie" className="btn-cta pro-btn-secondary">
              VOIR MON TRAVAIL
            </Link>
          </div>
        </div>
      </section>


      {/* INTRO */}
      <section className="pro-section">
        <div className="pro-container pro-intro">
          <p className="pro-eyebrow">VOTRE IMAGE</p>

          <h2>
            Vos clients découvrent souvent
            votre entreprise avant même de vous rencontrer.
          </h2>

          <p>
            Site internet, LinkedIn, réseaux sociaux, recrutement ou
            supports commerciaux : vos photographies participent directement
            à la perception de votre entreprise.
          </p>

          <p>
            Mon rôle est de créer une banque d’images professionnelle,
            cohérente et authentique, qui montre les personnes,
            le savoir-faire et l’univers derrière votre activité.
          </p>
        </div>
      </section>


      {/* SERVICES */}
      <section className="pro-section pro-section-light">
        <div className="pro-container">

          <p className="pro-eyebrow">PRESTATIONS</p>
          <h2 className="pro-center">
            Des images adaptées à votre activité.
          </h2>

          <div className="pro-services-grid">

            <article className="pro-card">
              <span>01</span>
              <h3>Portrait professionnel</h3>
              <p>
                Dirigeants, indépendants et collaborateurs.
                Des portraits naturels et professionnels pour LinkedIn,
                votre site et vos supports de communication.
              </p>
            </article>

            <article className="pro-card">
              <span>02</span>
              <h3>Équipe & collaborateurs</h3>
              <p>
                Des portraits homogènes et cohérents pour présenter
                les personnes qui font vivre votre entreprise.
              </p>
            </article>

            <article className="pro-card">
              <span>03</span>
              <h3>Reportage métier</h3>
              <p>
                Votre savoir-faire, vos gestes, vos locaux et votre quotidien
                photographiés de manière naturelle et valorisante.
              </p>
            </article>

            <article className="pro-card">
              <span>04</span>
              <h3>Événement professionnel</h3>
              <p>
                Séminaire, inauguration, conférence ou soirée :
                un reportage vivant et discret de votre événement.
              </p>
            </article>

          </div>
        </div>
      </section>


      {/* LOCAL */}
      <section className="pro-section">
        <div className="pro-container pro-local">

          <div>
            <p className="pro-eyebrow">PROXIMITÉ</p>

            <h2>
              Votre photographe professionnel
              à Tomblaine et Nancy.
            </h2>

            <p>
              Basé à Tomblaine, j’accompagne les entreprises,
              indépendants, artisans et professions libérales
              de Nancy et de son agglomération.
            </p>

            <p>
              Je me déplace directement dans votre entreprise afin
              de créer des images adaptées à votre environnement
              et à votre communication.
            </p>
          </div>

          <div className="pro-local-list">
            <span>Tomblaine</span>
            <span>Nancy</span>
            <span>Saint-Max</span>
            <span>Essey-lès-Nancy</span>
            <span>Pulnoy</span>
            <span>Seichamps</span>
            <span>Jarville</span>
            <span>Grand Nancy</span>
          </div>

        </div>
      </section>


      {/* PROCESS */}
      <section className="pro-section pro-section-dark">
        <div className="pro-container">

          <p className="pro-eyebrow pro-eyebrow-light">
            COMMENT ÇA SE PASSE ?
          </p>

          <h2 className="pro-center">
            Simple. Clair. Professionnel.
          </h2>

          <div className="pro-process-grid">

            <div>
              <strong>01</strong>
              <h3>Échange</h3>
              <p>
                Nous définissons votre besoin, vos objectifs
                et l’utilisation prévue des images.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h3>Préparation</h3>
              <p>
                Lieux, collaborateurs, tenues et type d’images :
                nous préparons la séance ensemble.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h3>Prise de vue</h3>
              <p>
                Je me déplace dans votre entreprise et vous guide
                tout au long de la séance.
              </p>
            </div>

            <div>
              <strong>04</strong>
              <h3>Livraison</h3>
              <p>
                Vos images sont sélectionnées, retouchées
                et livrées dans une galerie privée.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* TARIFS */}
      <section className="pro-section">
        <div className="pro-container">

          <p className="pro-eyebrow">TARIFS ENTREPRISE</p>

          <h2 className="pro-center">
            Une prestation adaptée à votre besoin.
          </h2>

          <p className="pro-pricing-intro">
            Chaque entreprise est différente. Le tarif dépend notamment
            du nombre de personnes, du temps de présence et des images
            dont vous avez besoin.
          </p>

          <div className="pro-pricing-grid">

  {/* FORMAT DÉCOUVERTE */}
  <article className="pro-price-card pro-price-featured">
    <p className="pro-price-label">FORMAT DÉCOUVERTE</p>

    <h3>Premiers visuels</h3>

    <div className="pro-price">
      dès <strong>290 € HT</strong>
    </div>

    <p className="pro-price-intro">
      Un premier format efficace pour moderniser rapidement
      l’image de votre entreprise.
    </p>

    <ul>
      <li>Environ 1 h de prise de vue sur site</li>
      <li>Portraits, équipe ou environnement</li>
      <li>Images sélectionnées et retouchées</li>
      <li>Livraison via galerie privée</li>
      <li>Déplacement inclus jusqu’à 30 km</li>
    </ul>

    <Link to="/contact" className="pro-price-cta">
      PARLER DE MON PROJET
    </Link>
  </article>


  {/* DEMI-JOURNÉE */}
  <article className="pro-price-card">
    <p className="pro-price-label">DEMI-JOURNÉE</p>

    <h3>Session Essentielle</h3>

    <div className="pro-price">
      <strong>600 € HT</strong>
    </div>

    <p className="pro-price-intro">
      Jusqu’à 4 heures pour constituer une sélection
      plus complète et variée.
    </p>

    <ul>
      <li>Jusqu’à 4 h de prise de vue</li>
      <li>Portraits individuels</li>
      <li>Photos d’équipe</li>
      <li>Reportage métier et scènes de travail</li>
      <li>Locaux et environnement professionnel</li>
      <li>Images sélectionnées et retouchées</li>
      <li>Livraison via galerie privée</li>
    </ul>

    <Link to="/contact" className="pro-price-cta">
      PARLER DE MON PROJET
    </Link>
  </article>


  {/* JOURNÉE */}
  <article className="pro-price-card">
    <p className="pro-price-label">JOURNÉE</p>

    <h3>Session Signature</h3>

    <div className="pro-price">
      <strong>1 100 € HT</strong>
    </div>

    <p className="pro-price-intro">
      Jusqu’à 8 heures pour créer une véritable banque
      d’images professionnelle et durable.
    </p>

    <ul>
      <li>Jusqu’à 8 h de prise de vue</li>
      <li>Portraits des dirigeants et collaborateurs</li>
      <li>Photos d’équipe</li>
      <li>Reportage métier approfondi</li>
      <li>Locaux, savoir-faire et environnement</li>
      <li>Plusieurs situations et ambiances</li>
      <li>Banque d’images pour web, LinkedIn et communication</li>
      <li>Livraison via galerie privée</li>
    </ul>

    <Link to="/contact" className="pro-price-cta">
      PARLER DE MON PROJET
    </Link>
  </article>

</div>

          <p className="pro-pricing-note">
            Besoin plus important ou projet spécifique ?
            Une proposition personnalisée peut être établie sur devis.
          </p>

        </div>
      </section>


      {/* CTA FINAL */}
      <section className="pro-final">
        <div className="pro-container">

          <p className="pro-eyebrow pro-eyebrow-light">
            PARLONS DE VOTRE ENTREPRISE
          </p>

          <h2>
            Et si vos prochaines photos
            donnaient enfin l’image que votre entreprise mérite ?
          </h2>

          <p>
            Expliquez-moi simplement votre besoin.
            Je vous proposerai une prestation adaptée à votre activité.
          </p>

          <Link to="/contact" className="btn-cta btn-cta-red">
            DEMANDER UN DEVIS
          </Link>

        </div>
      </section>

    </main>
  );
}